import React from 'react'

const YourCourse = () => {
  return (
    <div>
      your courses
    </div>
  )
}

export default YourCourse
